export function trackEvent(name, params = {}) {
    try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: name, ...params });
        if (window.posthog?.capture) window.posthog.capture(name, params);
    } catch {
        /* analytics must never break UX */
    }
}

export const EVENTS = {
    estimateClick: "get_estimate_click",
    estimateSubmit: "estimate_form_submitted",
    consultationSubmit: "consultation_submitted",
    siteVisitSubmit: "site_visit_submitted",
    whatsappClick: "whatsapp_click",
    phoneClick: "phone_click",
    directionsClick: "directions_click",
    packageViewed: "package_viewed",
    packageSelected: "package_selected",
    appCtaClick: "app_cta_click",
    contactSubmit: "contact_form_submitted",
};
